module.exports = __webpack_public_path__ + "media/images/utees-bg-56df4d7d3f9bc64a8a70debce16b1240.svg";